import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bf3a612"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "modal_title space-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "스톡옵션 추가", -1))
const _hoisted_4 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content_title" }, " 보유주식 회사이름 ", -1))
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "search_box" }
const _hoisted_8 = { class: "stock_info" }
const _hoisted_9 = {
  key: 1,
  class: "content_inner"
}
const _hoisted_10 = { class: "stocks-list" }
const _hoisted_11 = { id: "stocks-list" }
const _hoisted_12 = { class: "vote_top cursor" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "small_logo" }
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_17 = { class: "d" }
const _hoisted_18 = { class: "title" }
const _hoisted_19 = { class: "sub_info" }
const _hoisted_20 = ["disabled", "onClick"]
const _hoisted_21 = {
  key: 0,
  class: "starToggle",
  src: "/assets/icon/star_b.png"
}
const _hoisted_22 = {
  key: 1,
  class: "starToggle",
  src: "/assets/icon/star_g.png"
}
const _hoisted_23 = {
  key: 2,
  class: "search_box"
}
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "desc" }
const _hoisted_26 = {
  key: 1,
  class: "modal_content"
}
const _hoisted_27 = { class: "content_top" }
const _hoisted_28 = {
  key: 0,
  class: "content_title"
}
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 증명서류 ")
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "light" }, " - 주권미발행확인서 or 스톡옵션계약서 ", -1))
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "content-block" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "증명서류", -1))
const _hoisted_34 = { class: "select-file" }
const _hoisted_35 = { class: "file_info" }
const _hoisted_36 = {
  key: 0,
  class: "file_name"
}
const _hoisted_37 = {
  key: 1,
  class: "file_name"
}
const _hoisted_38 = {
  key: 2,
  class: "file_name"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "remove_img",
  src: "/assets/icon/edit_x_g.png",
  srcset: "/assets/icon/edit_x_g@2x.png 2x,/assets/icon/edit_x_g@3x.png 3x"
}, null, -1))
const _hoisted_40 = [
  _hoisted_39
]
const _hoisted_41 = {
  key: 0,
  class: "content_title"
}
const _hoisted_42 = { class: "content-block" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "행사 가능 기간", -1))
const _hoisted_44 = {
  key: 0,
  class: "date_box"
}
const _hoisted_45 = { class: "strong" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode(" 년 ")
const _hoisted_47 = { class: "strong" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 년 ")
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sorting",
  src: "/assets/icon/sorting_blue.png",
  srcset: "/assets/icon/sorting_blue@2x.png 2x,/assets/icon/sorting_blue@3x.png 3x"
}, null, -1))
const _hoisted_50 = {
  key: 1,
  class: "input_box date_box"
}
const _hoisted_51 = { class: "period disable_text" }
const _hoisted_52 = { class: "strong" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" 년 ")
const _hoisted_54 = { class: "strong" }
const _hoisted_55 = /*#__PURE__*/_createTextVNode(" 년 ")
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sorting",
  src: "/assets/icon/sorting_gray.png",
  srcset: "/assets/icon/sorting_gray@2x.png 2x,/assets/icon/sorting_gray@3x.png 3x"
}, null, -1))
const _hoisted_57 = {
  key: 0,
  class: "content_title"
}
const _hoisted_58 = { class: "content-block" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "계약 체결일", -1))
const _hoisted_60 = { class: "date_box strong" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sorting",
  src: "/assets/icon/sorting_blue.png",
  srcset: "/assets/icon/sorting_blue@2x.png 2x,/assets/icon/sorting_blue@3x.png 3x"
}, null, -1))
const _hoisted_62 = {
  key: 1,
  class: "date_box disable_text strong"
}
const _hoisted_63 = { style: {"width":"110px","display":"inline-block"} }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sorting",
  src: "/assets/icon/sorting_gray.png",
  srcset: "/assets/icon/sorting_gray@2x.png 2x,/assets/icon/sorting_gray@3x.png 3x"
}, null, -1))
const _hoisted_65 = {
  key: 0,
  class: "content_title"
}
const _hoisted_66 = { class: "content-block" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "주당 행사 가격", -1))
const _hoisted_68 = {
  key: 0,
  class: "input_box"
}
const _hoisted_69 = { class: "bold" }
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_71 = {
  key: 1,
  class: "label_box"
}
const _hoisted_72 = { class: "bold" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_74 = {
  key: 0,
  class: "content_title"
}
const _hoisted_75 = { class: "content-block" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "주식 수", -1))
const _hoisted_77 = {
  key: 0,
  class: "input_box"
}
const _hoisted_78 = { class: "bold" }
const _hoisted_79 = /*#__PURE__*/_createTextVNode(" 주")
const _hoisted_80 = {
  key: 1,
  class: "label_box"
}
const _hoisted_81 = { class: "bold" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" 주")
const _hoisted_83 = { class: "content-block" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "회사이름", -1))
const _hoisted_85 = { class: "label_box" }
const _hoisted_86 = { class: "bottom" }
const _hoisted_87 = { class: "pad-container" }
const _hoisted_88 = ["onClick"]
const _hoisted_89 = { class: "row" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "clear" }, "00", -1))
const _hoisted_91 = [
  _hoisted_90
]
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "0", -1))
const _hoisted_93 = [
  _hoisted_92
]
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/assets/icon/backspace@3x.png",
    class: "backSpace",
    alt: "backspace"
  })
], -1))
const _hoisted_95 = [
  _hoisted_94
]
const _hoisted_96 = { class: "content_bottom" }
const _hoisted_97 = ["disabled"]
const _hoisted_98 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, { "scroll-y": "false" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
          }, "취소")
        ])
      ]),
      (_ctx.checkProcessStatus(1))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            (!_ctx.keyInitemNameDriectly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_ion_searchbar, {
                      placeholder: "회사명, 종목(주식)코드 검색",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.display = true)),
                      onIonChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchKeyword($event))),
                      onIonClear: _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchCleared($event)))
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", {
                      class: "input-direct",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.requestItem()))
                    }, " 직접입력 ")
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.keyInitemNameDriectly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _withDirectives(_createElementVNode("div", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchStockItems, (stock) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: stock.stockItemId,
                          class: "vote_company main-deal"
                        }, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", {
                              class: "vote_top_left",
                              onClick: ($event: any) => (_ctx.setCompany(stock.stockItemName, stock.stockItemId))
                            }, [
                              _createElementVNode("div", _hoisted_14, [
                                _createElementVNode("img", {
                                  src: stock.companyLogo ? stock.companyLogo : '/assets/icon/company_default_img.png',
                                  onerror: "this.src='/assets/icon/company_default_img.png'",
                                  class: "img-responsive img-circle"
                                }, null, 8, _hoisted_15),
                                _hoisted_16
                              ]),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("div", _hoisted_18, _toDisplayString(stock.stockItemName), 1),
                                _createElementVNode("div", _hoisted_19, _toDisplayString(stock.codeNumber), 1)
                              ])
                            ], 8, _hoisted_13),
                            _createElementVNode("button", {
                              class: "ion-activatable ripple-parent vote_top_right",
                              disabled: ~['mna','ipo'].indexOf(stock.companyStatus),
                              onClick: ($event: any) => (_ctx.user === null ? _ctx.$global.openLoginModal() :_ctx.itemLikeCompany(stock.stockItemId))
                            }, [
                              (stock.likeFlag)
                                ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                                : (_openBlock(), _createElementBlock("img", _hoisted_22)),
                              _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                            ], 8, _hoisted_20)
                          ])
                        ]))
                      }), 128))
                    ], 512), [
                      [_vShow, _ctx.display]
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createVNode(_component_ion_input, {
                    type: "text",
                    onIonChange: _cache[5] || (_cache[5] = ($event) => _ctx.state.companyName = $event.detail.value)
                  }),
                  _withDirectives(_createElementVNode("button", {
                    class: "inline_btn",
                    disabled: _ctx.state.companyName === '',
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setProcessStatus('next')))
                  }, " 다음 ", 8, _hoisted_24), [
                    [_vShow, _ctx.checkProcessStatus(1)]
                  ])
                ])),
            _withDirectives(_createElementVNode("div", _hoisted_25, " 회사이름을 직접입력하여 등록합니다. ", 512), [
              [_vShow, _ctx.keyInitemNameDriectly]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.checkProcessStatus(2, 3, 4, 5, 6))
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              (_ctx.checkProcessStatus(6))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.checkProcessStatus(6))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_31))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, [
                        _createElementVNode("div", {
                          class: "browse",
                          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openFileSelector && _ctx.openFileSelector(...args)))
                        }, " 파일 선택 "),
                        _createElementVNode("input", {
                          id: "file_for_proof",
                          type: "file",
                          name: "file",
                          class: "file",
                          onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.checkFileValue($event)))
                        }, null, 32),
                        _createElementVNode("div", _hoisted_35, [
                          (_ctx.state.files)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.state.files.name), 1))
                            : (_ctx.stockMode === 'edit' && _ctx.editState.originalFileName)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.editState.originalFileName), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_38, " 선택된 파일이 없습니다. ")),
                          _withDirectives(_createElementVNode("div", {
                            class: "remove_file_btn",
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.removeFile && _ctx.removeFile(...args)))
                          }, _hoisted_40, 512), [
                            [_vShow, _ctx.state.files || (_ctx.stockMode === 'edit' && _ctx.editState.originalFileName)]
                          ])
                        ])
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.checkProcessStatus(5, 6))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.checkProcessStatus(5))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, " 행사 가능 기간 "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_42, [
                      _hoisted_43,
                      (_ctx.checkProcessStatus(5))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("div", {
                              class: "period",
                              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.openPicker(2, 15, _ctx.multiColumnOptions)))
                            }, [
                              _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.state.exerciseFrom), 1),
                              _hoisted_46,
                              _createElementVNode("span", _hoisted_47, "~ " + _toDisplayString(_ctx.state.exerciseTo), 1),
                              _hoisted_48
                            ]),
                            _hoisted_49
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.checkProcessStatus(5))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.state.exerciseFrom), 1),
                              _hoisted_53,
                              _createElementVNode("span", _hoisted_54, "~ " + _toDisplayString(_ctx.state.exerciseTo), 1),
                              _hoisted_55
                            ]),
                            _hoisted_56
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.checkProcessStatus(4, 5, 6))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.checkProcessStatus(4))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, " 계약 체결일 "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_58, [
                      _hoisted_59,
                      (_ctx.checkProcessStatus(4))
                        ? (_openBlock(), _createBlock(_component_ion_item, {
                            key: 0,
                            class: "ion-no-padding"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_60, [
                                _createVNode(_component_ion_datetime, {
                                  max: "2030-12-31",
                                  min: "1980-01-01",
                                  mode: "ios",
                                  value: _ctx.state.contractDate,
                                  "display-format": "YYYY.MM.DD",
                                  "picker-options": _ctx.customPickerOptions
                                }, null, 8, ["value", "picker-options"]),
                                _hoisted_61
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.checkProcessStatus(4))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.state.contractDate.replace(/-/gi, ".")), 1),
                            _hoisted_64
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.checkProcessStatus(3, 4, 5, 6))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    (_ctx.checkProcessStatus(3))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_65, " 주당 행사 가격 "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_66, [
                      _hoisted_67,
                      (_ctx.checkProcessStatus(3))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.$filters.currency(_ctx.state.exercisePrice)), 1),
                                _hoisted_70
                              ]),
                              _: 1
                            }),
                            _createElementVNode("img", {
                              src: "/assets/icon/x-circle.png",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearNumber('clear', _ctx.curStatus)))
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.checkProcessStatus(3))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_72, _toDisplayString(_ctx.$filters.currency(_ctx.state.exercisePrice)), 1),
                                _hoisted_73
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.checkProcessStatus(2, 3, 4, 5, 6))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    (_ctx.checkProcessStatus(2))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, " 스톡옵션 행사로 받을 주식의 수 "))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      (_ctx.checkProcessStatus(2))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.$filters.currency(_ctx.state.exerciseQty)), 1),
                                _hoisted_79
                              ]),
                              _: 1
                            }),
                            _createElementVNode("img", {
                              class: "x-circle",
                              src: "/assets/icon/x-circle@3x.png",
                              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.clearNumber('clear', _ctx.curStatus)))
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.checkProcessStatus(2))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.$filters.currency(_ctx.state.exerciseQty)), 1),
                                _hoisted_82
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_83, [
                _hoisted_84,
                _createElementVNode("div", _hoisted_85, [
                  _createVNode(_component_ion_label, { type: "text" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.state.companyName), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_86, [
              _withDirectives(_createElementVNode("div", _hoisted_87, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0,1,2], (row) => {
                  return _createElementVNode("div", {
                    key: row,
                    class: "row"
                  }, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (col) => {
                      return _createElementVNode("div", {
                        key: col,
                        class: "letter",
                        onClick: ($event: any) => (_ctx.addNumber(row * 3 + col, _ctx.curStatus))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(row * 3 + col), 1)
                      ], 8, _hoisted_88)
                    }), 64))
                  ])
                }), 64)),
                _createElementVNode("div", _hoisted_89, [
                  _createElementVNode("div", {
                    class: "letter",
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.addNumber('00', _ctx.curStatus)))
                  }, _hoisted_91),
                  _createElementVNode("div", {
                    class: "letter",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addNumber(0, _ctx.curStatus)))
                  }, _hoisted_93),
                  _createElementVNode("div", {
                    class: "letter",
                    onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.clearNumber('del', _ctx.curStatus)))
                  }, _hoisted_95)
                ])
              ], 512), [
                [_vShow, _ctx.checkProcessStatus(2) || _ctx.checkProcessStatus(3)]
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_96, [
                _withDirectives(_createElementVNode("button", {
                  class: "previous_btn",
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
                }, " 취소 ", 512), [
                  [_vShow, _ctx.checkProcessStatus(1)]
                ]),
                _withDirectives(_createElementVNode("button", {
                  class: "previous_btn",
                  disabled: _ctx.backBtnToggle && _ctx.checkProcessStatus(2),
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setProcessStatus('previous')))
                }, " 이전 ", 8, _hoisted_97), [
                  [_vShow, !_ctx.checkProcessStatus(1)]
                ]),
                _withDirectives(_createElementVNode("button", {
                  class: "next_btn",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setProcessStatus('next')))
                }, " 다음 ", 512), [
                  [_vShow, !_ctx.checkProcessStatus(6)]
                ]),
                _withDirectives(_createElementVNode("button", {
                  class: "next_btn",
                  disabled: !_ctx.doneBtnToggle||_ctx.isWaitingConfirm,
                  onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.sendPost && _ctx.sendPost(...args)))
                }, " 완료 ", 8, _hoisted_98), [
                  [_vShow, _ctx.checkProcessStatus(6)]
                ])
              ], 512), [
                [_vShow, !_ctx.checkProcessStatus(1)]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}